/**
 * @module Banners - Service Check - Single Line
 * @description Service Check Sticky Banner
 */
import { useContext } from "react";
import { FuelContext } from "@/providers/fuel-provider";
import PropTypes from "prop-types";
import ServiceCheckSingleLine from "@/blocks/ServiceCheckForm";
import styles from "./BannerServiceCheckSingleLine.module.css";

/**
 * @function Component
 * @description
 */
const Component = ({ ...props }) => {
  const { phoneHeavy } = useContext(FuelContext);
  const { theme = "light" } = props;

  if (phoneHeavy === true) {
    return <></>;
  }

  return (
    <section
      className={`component ${styles.component} ${theme && `u-theme-${theme}`}`}
    >
      <div className="l-container">
        <div className={styles.component__body}>
          <div className={styles.component__formWrapper}>
            <ServiceCheckSingleLine />
          </div>
        </div>
      </div>
    </section>
  );
};

Component.propTypes = {
  theme: PropTypes.string,
};

export default Component;
